import React from 'react';
import { arrayOf, shape, string, func } from 'prop-types';
import styled from 'styled-components';
import categoryProps from 'TMPropTypes/categoryProps';
import { breakpoints } from 'TMConstants';
import CategoryPill from 'TMComponents/CategoryPill';
import { H4 } from 'TMComponents/Typography';

const Wrapper = styled.div`
    margin-bottom: 32px;
`;

const FilterText = styled(H4)`
    margin-bottom: 0px;
    margin-top: 0;
`;

const CategoryList = styled.div`
    overflow-x: scroll;
    white-space: nowrap;
    padding-bottom: 8px;
    border-bottom: 2px solid
        ${({ theme }) => theme.colorSystem.UIElements[4]};

    @media (min-width: ${breakpoints.mobileTablet}px) {
        white-space: normal;
        border-bottom: none;
    }
`;

const CategoryFilter = ({ categories, selected, onClick }) => (
    <Wrapper>
        <FilterText>Categories:</FilterText>
        <CategoryList>
            {categories.map(({ name }) => (
                <CategoryPill
                    key={name}
                    allowToggle
                    name={name}
                    isActive={selected.includes(name)}
                    onClick={() => {
                        const newCategories = selected.slice();
                        if (newCategories.includes(name)) {
                            newCategories.splice(
                                newCategories.indexOf(name),
                                1
                            );
                        } else {
                            newCategories.push(name);
                        }
                        onClick(newCategories);
                    }}
                />
            ))}
        </CategoryList>
    </Wrapper>
);

CategoryFilter.propTypes = {
    categories: arrayOf(shape(categoryProps)).isRequired,
    selected: arrayOf(string).isRequired,
    onClick: func.isRequired
};

export default CategoryFilter;
